import React from 'react';
import Helmet from 'react-helmet';
import _ from 'lodash';
import Moment from 'moment';
import {
  SafetyDiaryRecoveryForm,
  SafetyDiaryRecoveryFormData,
} from '../components/forms/SafetyDiaryRecoveryForm';
import Information from '../components/modals/common/Information';
import { SafetyDiaryService } from '../services/SafetyDiaries';
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import { messageUtility } from '../utilities/messageUtility';
import _slideLoader from '../utilities/slideLoader';
import SafetyDiariesConstants from '../utilities/safetyDiariesConstants';
import { HEADER_CONSTANTS, DIRECT_STATUS_CODE } from '../utilities/constants';
import { getSafetyDiaryDetailPageName } from '../utilities/roleUtility';
import { ConferencePageHeader } from '../components/PageHeader';
import dialogLoader from '../utilities/dialogLoader';
import { CloseEditView } from '../components/CloseEditView';
import Confirmation from '../components/modals/common/Confirmation';
import FieldService from '../services/Fields';
import ExternalServiceCooperationStatusApi from '../services/ExternalServiceCooperationStatusApi';
import { localizeMessage } from '../utilities/validateMessage';

// ダイアログ名
const DIALOG_NAME = {
  errorfileType: 'errorfileType', // ファイルタイプエラー
  errorfileSize: 'errorfileSize', // ファイルサイズエラー
  movePage: 'movePage',
};

/**
 * @description 巡回記録是正報告画面
 */
export class SafetyDiariesRecoveryRegister extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fieldId: SessionStorageService.getFieldId(),
      userId: LocalStorageService.getUserId(),
      formData: SafetyDiaryRecoveryFormData,
      dataId: this.props.view.state.id || null,
      modalState: false,
      validateMessages: {}, // バリデーションメッセージ
      visibleDialogName: null, // ダイアログ名
      externalServiceCooperationStatus: {
        line_works: {
          available: false,
        },
        direct: {
          available: null,
          reason_code: null,
        },
      },
      directTalkRooms: [],
      lwTalkRooms: [],
      callApiDirectTalkRoomStatus: null,
    };
    this.handleRegsiterRecovery = this.handleRegsiterRecovery.bind(this);
    this.validate = this.validate.bind(this);
    this.handleVisibleDialog = this.handleVisibleDialog.bind(this); // ダイアログ開閉設定
    this.prevUpdateFormData = null;
  }

  componentDidMount() {
    // 更新時
    if (this.state.dataId) {
      this.setState({ formData: SafetyDiaryRecoveryFormData });
      const params = this.props.view.state.params || {
        date_type: SafetyDiariesConstants.dataType.entriesDate,
      };
      SafetyDiaryService.getDiary(
        this.state.fieldId,
        this.state.dataId,
        params
      ).then(response => {
        if (!response.result) {
          alert('データの読み込みに失敗しました。');
          return;
        }
        const safetyDiary = response.data.entities.safety_diary;
        const fixDateFormData = safetyDiary.recovery_date
          ? { ...safetyDiary }
          : { ...safetyDiary, recovery_date: Moment().format('YYYY/MM/DD') };
        this.setState({ formData: fixDateFormData });
        this.prevUpdateFormData = fixDateFormData;
      });
    }
    this.getExternalServiceCooperationStatus();
  }

  createPostDataFromFormData = formData => {
    let postData = SafetyDiaryRecoveryFormData;
    _.each(_.keys(postData), k => {
      postData[k] = formData[k] ? formData[k] : '';
    });

    postData.send_external_service_cooperation =
      postData.report_send_external_service_cooperation;
    postData.lw_talkroom_ids = [];
    postData.direct_talkroom_ids = [];
    if (Number(postData.send_external_service_cooperation)) {
      postData.lw_talkroom_ids = _.map(
        postData.report_lw_talkroom_ids,
        _.toString
      );
      postData.direct_talkroom_ids = _.map(
        postData.report_direct_talkroom_ids,
        _.toString
      );
    }
    postData = _.omit(postData, [
      'report_lw_talkroom_ids',
      'report_direct_talkroom_ids',
      'report_send_external_service_cooperation',
    ]);
    return postData;
  };

  renderChangeEditButton = () => {
    if (this.state.dataId) {
      return (
        <React.Fragment>
          {this.state.formData.recovery_flag === 0 && (
            <button className='btn--stay' onClick={this.handleEditConfirm}>
              指摘事項を確認する
            </button>
          )}
        </React.Fragment>
      );
    }

    return null;
  };

  handleOpenNewSlide = object => {
    _slideLoader.close(this.props.vw);
    _slideLoader.show(
      object.name,
      { state: { ...object.state } },
      this.props.vw
    );
  };

  handleEditConfirm = () => {
    if (
      _.isEqual(this.state.formData, this.prevUpdateFormData) &&
      _.isEmpty(this.state.validateMessages)
    ) {
      this.handleOpenNewSlide({
        name: getSafetyDiaryDetailPageName(this.state.formData),
        state: {
          ...this.props.view.state,
          id: this.state.dataId,
          dataId: this.state.dataId,
        },
      });
    }
    this.handleVisibleDialog(DIALOG_NAME.movePage);
  };

  handleRegsiterRecovery = () => {
    // 是正内容エラーチェック
    if (!this.validate()) {
      return;
    }

    const recovery_date = Moment(this.state.formData.recovery_date).format(
      'YYYYMMDD'
    );

    const postData = {
      ...this.state.formData,
      recovery_flag: 1,
      recovery_user_id: this.state.userId,
      recovery_date,
      field_id: this.state.fieldId,
      id: this.state.dataId,
      recovery_update_time: Moment(),
    };

    const postDataForm = this.createPostDataFromFormData(postData);
    SafetyDiaryService.registerRecovery(
      this.state.fieldId,
      this.state.dataId,
      postDataForm
    ).then(response => {
      if (!response.result) {
        return;
      }
      this.handleOpenNewSlide({
        name: 'SafetyDiariesConfirm',
        state: {
          ...this.props.view.state,
          id: this.state.dataId,
          dataId: this.state.dataId,
        },
      });
    });
  };

  /**
   * 編集やXボタン押下後
   * 巡回記録詳細・編集画面へ遷移
   *
   * @memberof SafetyDiariesRecoveryRegister
   */
  handleFormChange() {
    _slideLoader.show(
      SafetyDiariesConstants.pageName.safetyDiaries,
      {
        state: {
          id: 1,
        },
      },
      this.props.vw
    );
    this.setState({ modalState: true });
  }

  /**
   * @description バリデーションチェック
   * @param {string} key フォーム名 ※是正完了ボタン押下後は、nullがセット
   * @param {string | object} value 入力値 ※是正完了ボタン押下後は、nullがセット
   */
  validate(key = null, value = null) {
    let validateMessages = _.cloneDeep(this.state.validateMessages);

    // 是正報告日
    if (key === 'recovery_date' || _.isNull(key)) {
      const recoveryDate = !_.isNull(key)
        ? value
        : this.state.formData.recovery_date;
      if (
        !Moment(recoveryDate).isBetween(
          this.state.formData.entries_date,
          Moment().format('YYYY/MM/DD'),
          null,
          '[]'
        )
      ) {
        validateMessages.recovery_date = messageUtility.getMessage('E-001-310');
      } else {
        delete validateMessages.recovery_date;
      }
    }

    // 是正内容
    if (key === 'recovery_contents' || _.isNull(key)) {
      const recoveryContents = !_.isNull(key)
        ? value
        : this.state.formData.recovery_contents;
      if (_.isEmpty(recoveryContents)) {
        validateMessages.recovery_contents = messageUtility.getMessage(
          'E-000-010'
        );
      } else {
        delete validateMessages.recovery_contents;
      }
    }
    if (
      _.includes(['report_lw_talkroom_ids', 'report_direct_talkroom_ids'], key)
    ) {
      if (_.get(value, 'report_send_external_service_cooperation')) {
        if (
          !_.isEmpty(value['report_lw_talkroom_ids']) ||
          !_.isEmpty(value['report_direct_talkroom_ids'])
        ) {
          validateMessages = this.removeReportTalkRoomMsg(validateMessages);
        } else {
          validateMessages[key] = localizeMessage.required;
        }
      } else {
        validateMessages = this.removeReportTalkRoomMsg(validateMessages);
      }
    }
    if (key === 'report_send_external_service_cooperation') {
      if (!Number(value)) {
        validateMessages = this.removeReportTalkRoomMsg(validateMessages);
      }
    }
    if (_.isNull(key)) {
      validateMessages = this.handleValidateAllTalkRoom(validateMessages);
    }
    this.setState({ validateMessages });

    if (_.isNull(key)) {
      return _.isEmpty(validateMessages);
    }
  }

  /**
   * @description ダイアログ開閉設定
   * @param {string} visibleDialogName ダイアログ名(DIALOG_NAME)
   *                                   ※ nullの場合は、ダイアログを閉じる
   */
  handleVisibleDialog(visibleDialogName) {
    this.setState({ visibleDialogName });
  }

  onClose = () => {
    dialogLoader.show(CloseEditView, {
      callback: {
        close: () => {
          dialogLoader.close();
        },
        clear: () => {
          dialogLoader.close();
          this.handleFormChange();
        },
      },
    });
  };

  /**
   * Handle validate talk room when submit
   * @returns {PartialObject<object>|*}
   */
  handleValidateAllTalkRoom = validateMessages => {
    const {
      formData: {
        report_send_external_service_cooperation,
        report_lw_talkroom_ids,
        report_direct_talkroom_ids,
      },
      externalServiceCooperationStatus: { line_works, direct },
    } = this.state;
    const keyTalkRoom = [
      'report_lw_talkroom_ids',
      'report_direct_talkroom_ids',
    ];
    if (!Number(report_send_external_service_cooperation)) {
      return _.omit(validateMessages, keyTalkRoom);
    }
    const isRequiredLw = line_works.available;
    const isRequiredDirect =
      direct.available || direct.reason_code === DIRECT_STATUS_CODE.UNAVAILABLE;

    if (isRequiredLw && isRequiredDirect) {
      if (
        !_.isEmpty(report_lw_talkroom_ids) ||
        !_.isEmpty(report_direct_talkroom_ids)
      ) {
        return _.omit(validateMessages, keyTalkRoom);
      }
      _.forEach(keyTalkRoom, key => {
        validateMessages[key] = localizeMessage.required;
      });
      return validateMessages;
    }
    if (isRequiredLw) {
      if (_.isEmpty(report_lw_talkroom_ids)) {
        validateMessages.report_lw_talkroom_ids = localizeMessage.required;
      } else {
        validateMessages = _.omit(validateMessages, 'report_lw_talkroom_ids');
      }
      return validateMessages;
    }
    if (isRequiredDirect) {
      if (_.isEmpty(report_direct_talkroom_ids)) {
        validateMessages.report_direct_talkroom_ids = localizeMessage.required;
      } else {
        validateMessages = _.omit(
          validateMessages,
          'report_direct_talkroom_ids'
        );
      }
      return validateMessages;
    }
    return validateMessages;
  };

  getExternalServiceCooperationStatus = async () => {
    const response = await ExternalServiceCooperationStatusApi.list.get({
      field_id: this.state.fieldId,
    });
    if (response.result) {
      const externalServiceCooperationStatus = _.get(response, 'data.entities');
      this.setState(
        {
          externalServiceCooperationStatus,
        },
        () => {
          if (_.get(externalServiceCooperationStatus, 'line_works.available')) {
            this.getLwTalkRoom();
          }
          if (_.get(externalServiceCooperationStatus, 'direct.available')) {
            this.checkDirectTalkRoom();
          }
        }
      );
    }
  };

  checkDirectTalkRoom = async () => {
    let status = false;
    let directTalkRooms = [];
    const response = await FieldService.listDirectRooms({
      field_id: this.state.fieldId,
    });
    if (response.result) {
      status = true;
      directTalkRooms = _.get(response, 'data.entities.direct_talkrooms') || [];
    }
    this.setState({
      callApiDirectTalkRoomStatus: status,
      directTalkRooms,
    });
  };

  /**
   * get list LineWorks talk room
   */
  getLwTalkRoom = async () => {
    const response = await FieldService.listLwTalkRoom(this.state.fieldId);
    if (response.result) {
      this.setState({
        lwTalkRooms: _.get(response, 'data.entities.lw_talkrooms') || [],
      });
    }
  };

  removeReportTalkRoomMsg = validateMessages => {
    return _.omit(validateMessages, [
      'report_lw_talkroom_ids',
      'report_direct_talkroom_ids',
    ]);
  };

  render() {
    return (
      <div className='slide-view show'>
        <Helmet>
          <title>{`${HEADER_CONSTANTS.conference} - 是正内容編集`}</title>
        </Helmet>
        <div className='slide-view__view'>
          <ConferencePageHeader
            dataTestId={`safety-diaries-recovery-register`}
            title={<div className='slide-view__title'>是正内容編集</div>}
            leftComponent={
              <React.Fragment>
                <button
                  className='btn--effective'
                  onClick={this.handleRegsiterRecovery}
                >
                  是正完了
                </button>
                {this.state.formData.recovery_flag === 0 &&
                  this.renderChangeEditButton()}
              </React.Fragment>
            }
            rightComponent={
              <div className='slide-view__header-end-item'>
                <div className='form-list__header-alert show'>
                  {_.isEmpty(this.state.validateMessages)
                    ? ''
                    : '入力エラーがあります。'}
                </div>
              </div>
            }
            onClose={this.onClose}
          />

          <div className='slide-view__body SafetyDiaries'>
            <SafetyDiaryRecoveryForm
              onUpdate={formData => {
                this.setState({ formData });
              }}
              errors={this.state.validateMessages}
              validate={this.validate}
              dataId={this.state.dataId}
              params={this.props.view.state.params}
              onVisibleDialog={this.handleVisibleDialog}
              isSpace={true}
              externalServiceCooperationStatus={
                this.state.externalServiceCooperationStatus
              }
              callApiDirectTalkRoomStatus={
                this.state.callApiDirectTalkRoomStatus
              }
              directTalkRooms={this.state.directTalkRooms}
              lwTalkRooms={this.state.lwTalkRooms}
            />
          </div>
        </div>
        <Information
          visible={this.state.visibleDialogName === DIALOG_NAME.errorfileType}
          title='対応していない画像形式です'
          message={messageUtility.getMessage('E-000-012')}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => this.handleVisibleDialog(null)}
          multilineText={true}
        />
        <Information
          visible={this.state.visibleDialogName === DIALOG_NAME.errorfileSize}
          title='ファイルサイズが大きすぎます'
          message={messageUtility.getMessage('E-001-314')}
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => this.handleVisibleDialog(null)}
          multilineText={true}
        />
        <Confirmation
          title='変更内容の保存'
          visible={this.state.visibleDialogName === DIALOG_NAME.movePage}
          message={
            <React.Fragment>
              <div>現在開いているページの内容が変更されています。</div>
              <div>ページを移動する前に、変更を保存してよろしいですか？</div>
            </React.Fragment>
          }
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          confirmButtonText='保存して是正完了'
          onConfirm={() => {
            this.handleRegsiterRecovery();
            this.handleVisibleDialog(null);
          }}
          onCancel={() => {
            this.handleVisibleDialog(null);
          }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/SafetyDiariesRecoveryRegister.jsx